import React, { FC } from 'react';
import { Controller, useWatch } from 'react-hook-form';

// Components
import FileSelector from '@/components/FileSelector';

// Types
import { EditStylesProps } from '@/types';

const EditGeneralStylesForm: FC<EditStylesProps> = ({
  register,
  chartData,
  control,
}) => {
  const chartBackground = useWatch({
    control,
    defaultValue: '#FFFFFF',
    name: 'theme.background',
  });

  return (
    <div>
      <h5 className="text-lg pt-4 pb-2 font-bold">General</h5>
      <div className="flex flex-col py-1">
        <label htmlFor="chart-header">Encabezado:</label>
        <input
          type="text"
          id="chart-header"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('chartHeader')}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="chart-header-font-size">
          Tamaño de la fuente del encabezado (en pixeles):
        </label>
        <input
          type="number"
          step="0.001"
          min="0"
          id="chart-header-font-size"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('chartHeaderFontSize', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="max-value">
          Valor máximo sobre el eje <em>x</em>:
        </label>
        <input
          type="number"
          step="0.001"
          id="max-value"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('chartMaxXValue', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="min-value">
          Valor mínimo sobre el eje <em>x</em>:
        </label>
        <input
          type="number"
          step="0.001"
          id="min-value"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('chartMinXValue', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="max-value">
          Valor máximo sobre el eje <em>y</em>:
        </label>
        <input
          type="number"
          step="0.001"
          id="max-value"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('chartMaxYValue', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="min-value">
          Valor mínimo sobre el eje <em>y</em>:
        </label>
        <input
          type="number"
          step="0.001"
          id="min-value"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('chartMinYValue', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="chart-background">Fondo de las gráficas:</label>
        <div className="w-full flex items-center py-2">
          <span className="pr-3">{(chartBackground || '').toUpperCase()}</span>
          <input
            type="color"
            id="chart-background"
            disabled={chartData.length === 0}
            className="w-6 h-6 cursor-pointer"
            {...register('theme.background')}
          />
        </div>
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="icon-selector">Ícono:</label>
        <Controller
          name="chartIcon"
          control={control}
          render={({ field }) => (
            <FileSelector
              onFileLoad={(file) => {
                const fileReaderInstance = new FileReader();
                fileReaderInstance.readAsDataURL(file);
                fileReaderInstance.onload = () => {
                  const base64data = fileReaderInstance.result;

                  field.onChange(base64data);
                };
              }}
              id="icon-selector"
              multiple={false}
              accept="image/*"
              maxFiles={1}
            />
          )}
        />
      </div>
    </div>
  );
};

export default EditGeneralStylesForm;
